import { PRODUCTS_STATS_EVENTS } from './global-events';

export const productsSlideMenuItems = [
  {
    name: 'Статистика продажів ₴',
    event: PRODUCTS_STATS_EVENTS.PRODUCTS_STATS_AMOUNT,
  },
  {
    name: 'Статистика продажів ШТ',
    event: PRODUCTS_STATS_EVENTS.PRODUCTS_STATS_COUNT,
  },
  {
    name: 'Комісійні винагороди ₴',
    event: PRODUCTS_STATS_EVENTS.PRODUCTS_STATS_EARNINGS,
  },
];
